import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { api } from 'constants/api';
import { AttributeType } from 'types/create-campaign';
import { ApiError, ApiResponse } from 'types/utils/api-response';
import { QueryOptions } from 'types/utils/query-options';

export type AttributesListResponseType = AttributeType[];

export const useGetAttributesList = (
  options: QueryOptions<AttributesListResponseType, AxiosError<ApiError>> = {}
) =>
  useQuery({
    queryFn: async (): Promise<AttributesListResponseType> => {
      const { data } =
        await api.get<ApiResponse<AttributesListResponseType>>(
          `/attribute/list`
        );

      return data.data;
    },
    queryKey: ['attributes'],
    ...options,
  });
